import { Button, Col, Form, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import { cloneDeep, isEmpty } from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputDate, FormSelect, FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import {
  BF_VALIDATION_REGEX, GROUP_POLICY_HDFC,
  GUTTOR_SPACE, VALIDATE_MESSAGES, ONLY_NUMBER_REGEX,
} from '../../../../../../shared/constants/commonConstants';
import {
  BENEFICIARY_SEARCH_OPTION, BENEFICIARY_SEARCH_OPTION_ABHI, DEFAULT_ADMISSION_FORM_VALUE,
  GOVT_SCHEME_SEARCH_OPTION, BENEFICIARY_SEARCH_OPTION_MDI, PATIENT_NAME_MAX_CHAR_LIMIT,
  BENEFICIARY_SEARCH_OPTION_SHAI,
  CORPRATE_NAME_REGEX,
  BENEF_CONSTANTS,
  BENEF_NOT_FOUND_MESSAGE,
  MDI_MEMBERID_PREFIX,
  EMPLOYEE_ID_REGEX,
  POLICY_TYPE_OPTIONS,
  BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID,
  BENEF_RETRY_MESSAGE,
  MDI_RETAIL_POLICY_ERROR_MESSAGE,
  PATIENT_NAME_MIN_CHAR_LIMIT,
} from '../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../store';
import * as actions from '../../../../../../store/actions/newAdmissionAction';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import { centeredNotification, formatName } from '../../../../../../utils/utility';
import {
  abhiValidation, customGTMEvent, getMessageForDisplay, getPolicyCheck, getPolicyGroup, otherPolicyValidation, policyValidation,
  policyWarning, filterBeneficiaries,
} from '../../../service/crmUtils';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import {
  setBeneficiarySearchResponsePayerId, setShowPayerNotConfiguredMessage,
  setShowPayerUpdatedMessage, setAllowNextStage, setStarDisabledBenefMessage, setHyphenGroup,
} from '../../../../../../store/actions/newAdmissionAction';
import { isBefore, startOfDay } from 'date-fns';

const BeneficiarySearchPanel = (props: any): ReactElement => {
  const { form, isLoading } = props;
  const [benefForm] = Form.useForm();
  const [selectedBenefSearch, setSelectedBenefSearch] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [currentGrp, setCurrentGrp] = useState('');
  const [policyWarn, setPolicyWarn] = useState<boolean>(true);
  const [policyCheck, setPolicyCheck] = useState<boolean>(false);
  const [memberIdCheck, setMemberIdCheck] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(false);
  const [count, setCount] = useState(0);
  const [showRetryMessage, setShowRetryMessage] = useState(false);
  const [displayMessage, setRetryDisplayMessage] = useState(<></>);
  const [prevSelectedBenefSearch, setPrevSelectedBenefSearch] = useState('');
  const [searchOptionCounts, setSearchOptionCounts] = useState<Record<string, number>>({});
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [ClaimCreationWithoutBenef, setClaimCreationWithoutBenef] = useState<boolean>(false);
  const [policyTypeValue, setIsPolicyTypeSelected] = useState<string>('');
  const { payer: { isClaimCreationBlockedWithoutBenef, isBenefSearchEnabled,
    isGovtScheme, name: payerName, value: payerValue, shortName } }
    = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { formControlConfig, payer, allPayers } = useSelector((state: RootState): PayerInitialState =>
    state.payerList);
  const commonDetails = { loading, benefForm, isLoading };
  const isContractedProvider = ApplicationDetail.instance.getIsContractedHospital();
  const commonDetail = { form: benefForm };

  const payerConfigValues = Object.values(formControlConfig);
  const combiPolicyExist = payerConfigValues?.some((config: any): any => Boolean(config?.combiPolicyExist));
  const isPolicyWarningEnabled = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'ABHI_POLICY_WARNING'
    && !hidden).length > 0;
  const isPolicyGroupEnabled = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'ABHI_POLICY_GROUP'
    && !hidden).length > 0;
  const isOptionalBenefFields = Boolean(payerConfigValues?.filter(({ type, hidden }: any): boolean =>
    type === 'BENEF_OPTIONAL_CRITERIA' && !hidden).length);
  const isPolicyNoReqForEmpId = (payerConfigValues?.some(({ type, hidden }: any): boolean =>
    (type === 'isReqForEmpId' && !hidden))) || false;
  const productNameTobeShown = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  const isManipalPayer: boolean = payerConfigValues?.some((config: any): boolean => Boolean(config?.isManipalClaim)) ?? false;
  const isVoloIPPPayer: boolean = payerConfigValues?.some((config: any): boolean => Boolean(config?.isVoloIPPClaim)) ?? false;
  const dateOfBirthRequired = (payerConfigValues?.some(({ type, hidden }: any): boolean =>
    (type === 'DOB_REQUIRED_FOR_BENEF' && hidden))) || false;
  const todayDate = startOfDay(new Date());
  const enableSubmissionForContracted = payerConfigValues?.some((config: any): boolean => (config?.allowSubmissionForContracted))
    && isContractedProvider;
  const isOnlyMemberIdBenefField = payerConfigValues?.some(({ type, hidden }: any): boolean =>
  type === 'ONLY_MEMBER_ID_BENEF_FIELD' && !hidden);
  const inMinCharacterValidationRequired = Boolean(payerConfigValues?.filter(({type, hidden}: any): boolean =>
    type === 'MIN_CHARACTER_VALIDATION' && !hidden).length);

  const onSearchChange = (value: any): void => {
    dispatch(setHyphenGroup(false));
    dispatch(setShowPayerNotConfiguredMessage(false));
    setSelectedBenefSearch(value);
    dispatch(actions.getSelectedSearchType(value));
    setShowRetryMessage(false);
    setRetryDisplayMessage(<></>);
    if (isOptionalBenefFields) {
      benefForm.resetFields(['memberId']);
    }
  };
  const { selectedPatientDetail } = useSelector((state: RootState): any => state.hospital);
  const { selectedPolicyDetail, memberName } = useSelector((state: RootState): NHCXState => state.nhcx);
  const { beneficiarySearchResponsePayerId, hyphenatedBasedGroupPolicy }: any =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);

  const onClickSearch = (formVal: any): void => {
    setPrevSelectedBenefSearch(selectedBenefSearch);
    dispatch(actions.setSelectedCardIndex(-1));

    customGTMEvent({
      event: 'WA_BENEFC_SEARCH',
    });
    initiateMemberForm();

    const formattedMemberId = (isOptionalBenefFields && selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[0]) ? `${MDI_MEMBERID_PREFIX}${formVal.memberId}` : formVal?.memberId;
    const newAdminssionSearchVal = {
      ...formVal,
      fullName: formVal?.patientName || '',
      payer: payerName,
      memberId: formattedMemberId,
    };

    const updatedFormValues = {
      ...formVal,
      memberId: formattedMemberId,
    };

    form?.resetFields();
    if (Object.keys(formVal).length) {
      setLoading(true);
      setCount(count + 1);
      dispatch(actions.setNewAdminssionSearchVal(newAdminssionSearchVal));
      dispatch(actions.benefSearch(updatedFormValues, updateBeneficiaryList, failedBeneficiarySearch));
    }
  };

  const initiateMemberForm = (): void => {
    dispatch(actions.setBeneficiaryList([]));
    dispatch(actions.sethospDetailsForRoomType({}));
    dispatch(actions.setIsShowAdmissionForm(false));
    dispatch(actions.setShowBeneficiaryCard(true));
    dispatch(actions.setSelectedBeneficiary(null));
    dispatch(actions.setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(actions.setUploadedFiles([]));
    dispatch(actions.setIsAbhaVerified(false, {}));
    dispatch(setShowPayerNotConfiguredMessage(false));
    dispatch(setShowPayerUpdatedMessage(false));
    dispatch(setAllowNextStage(true));
    dispatch(setStarDisabledBenefMessage(''));
    dispatch(actions.setHospitalOtherRoomType(''));
  };

  useEffect((): any => {
    const showClaimFormWithoutBenef = Object.values(searchOptionCounts).some((value: number): boolean => value > 1);
    setClaimCreationWithoutBenef(showClaimFormWithoutBenef);
    if (showClaimFormWithoutBenef) {
      if (!isClaimCreationBlockedWithoutBenef || enableSubmissionForContracted) {
        handleManualSubmissionFlow();
      }
    }
  }, [searchOptionCounts]);

  useEffect((): void => {
    benefForm.setFieldsValue({ 'iHave': '' });
  }, []);

  useEffect((): any => {
    setShowRetryMessage(false);
    setCount(0);
    setIsPolicyTypeSelected('');
  }, [payer]);

  useEffect((): void => {
    setRetryDisplayMessage(getMessageForDisplay(prevSelectedBenefSearch, isOptionalBenefFields, benefForm));
  }, [count]);

  useEffect((): void => {
    if (beneficiarySearchResponsePayerId === 0) {
      const selectedValue =
        isBenefSearchEnabled ?
          (isGovtScheme ? GOVT_SCHEME_SEARCH_OPTION?.[payerName]?.[0] : '') // adding null check
          : '';
      benefForm.setFieldsValue({
        'iHave': selectedValue,
        Payer: payerValue,
        policyNumber: '',
        corporateName: '',
        memberId: '',
        patientName: '',
        employeeId: '',
      });
      setCurrentGrp('');
      setSelectedBenefSearch(selectedValue);
    }
  }, [isGovtScheme, payerName]);

  const validateFields = (): any => {
    setTimeout((): any => {
      benefForm
        ?.validateFields()
        .then((): any => {
          if (isOptionalBenefFields) {
            setDisable(checkValidatedFields());
          } else {
            setDisable(true);
          }
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisable(false);
          }
        });
    }, 200);
  };

  const checkIfDobDisabled = (current: Date): boolean => {
    return isBefore(startOfDay(current), todayDate);
  };

  const checkValidatedFields = (): boolean => {
    const { memberId, policyNumber, patientName, employeeId } = benefForm.getFieldsValue([
      'policyNumber',
      'memberId',
      'patientName',
      'employeeId',
    ]);
    const hasValidFields = (primary: string | undefined, secondary: (string | undefined)[]): boolean =>
      !!primary && secondary.some((field: any): any => !!field);

    if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[0]) {
      return hasValidFields(memberId, [policyNumber, patientName, employeeId]);
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[1]) {
      return hasValidFields(employeeId, [memberId, policyNumber, patientName]);
    }
    return hasValidFields(policyNumber, [memberId, patientName, employeeId]);
  };

  useEffect((): any => {
    if (!isEmpty(selectedPatientDetail)) {
      benefForm?.setFieldsValue(selectedPatientDetail?.patientDetails || selectedPatientDetail);
      benefForm?.setFieldsValue(
        { patientName: formatName(selectedPatientDetail?.memberName || selectedPatientDetail?.patientDetails?.patientName) });

    }
    if (!isEmpty(selectedPolicyDetail)) {
      benefForm?.setFieldsValue({ memberId: selectedPolicyDetail?.memberId });
      benefForm?.setFieldsValue({ patientName: memberName });
      benefForm?.setFieldsValue({ policyNumber: selectedPolicyDetail?.policyNo || selectedPolicyDetail?.productId });
    }

  }, [selectedPatientDetail, selectedPolicyDetail, payer]);

  const updateBeneficiaryList = (benefList: any[]): void => {
    setLoading(false);
    setShowRetryMessage(false);
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = allPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (!finalPayer) {
        dispatch(setBeneficiarySearchResponsePayerId(0));
        return;
      }
    }
    const finalList = filterBeneficiaries(isOptionalBenefFields, selectedBenefSearch, benefList, failedBeneficiarySearch);

    dispatch(actions.setBeneficiaryList(finalList));
  };

  const failedBeneficiarySearch = (errorMsg: string, allowNextStage: any, retryMessage: any): void => {
    setErrorMessage(errorMsg);
    setSearchOptionCounts((prev: Record<string, number>): Record<string, number> => {
      const currentCount = prev[selectedBenefSearch] || 0;
      return {
        ...prev,
        [selectedBenefSearch]: currentCount + 1,
      };
    });
    setShowRetryMessage(false);
    let enableManual = false;
    setLoading(false);
    if (retryMessage !== 'Bad Gateway') { // incase of beneficiary search timeout
      setShowRetryMessage(retryMessage);
    }
    if (isOptionalBenefFields && policyTypeValue === POLICY_TYPE_OPTIONS.SECTOR_TYPES[0] &&
      errorMsg.includes(MDI_RETAIL_POLICY_ERROR_MESSAGE)) {
      setRetryDisplayMessage(BENEF_RETRY_MESSAGE.MDI_CORPORATE_SEARCH_INFO);
    }
    // the below check is to disable form submission if the 'isClaimCreationBlocked' flag is true [IPP-3655] and
    // allow submission for HDFC only after 1 retry [IPP-4370]
    if (!(isClaimCreationBlockedWithoutBenef) || enableSubmissionForContracted) {
      // if claim creation is not blocked and it's a non-HDFC payer
      if (!retryMessage) {
        // Set enableManual to true only if allowNextStage is not 'NO' and count is 1 or less
        enableManual = String(allowNextStage)?.toUpperCase() !== 'NO' && count <= 1;
      }

      // Explicitly set enableManual to false if count is more than 1 and allowNextStage is 'NO'
      if (count >= 1 && String(allowNextStage)?.toUpperCase() === 'NO') {
        enableManual = false;
      }
      if (enableManual) {
        handleManualSubmissionFlow();
      }
    } else {
      centeredNotification(errorMsg);
    }
  };

  const handleManualSubmissionFlow = (): void => {
    centeredNotification(enableSubmissionForContracted ? BENEF_NOT_FOUND_MESSAGE : errorMessage);
    dispatch(actions.enableManualSubmission());
    enableAdmissionForm();
  };

  const enableAdmissionForm = (): void => {
    dispatch(actions.setIsShowAdmissionForm(true));
    dispatch(actions.setSelectedBeneficiary(null));
  };

  const memberIDvalidation = (event: any): any => {
    const memberId = event?.target?.value;
    setMemberIdCheck(false);
    if (shortName === 'ABHI' && BF_VALIDATION_REGEX.test(String(memberId)?.toUpperCase())) {
      setMemberIdCheck(true);
    }
  };

  const onChangePolicyType = (): void => {
    const { policyType } = benefForm?.getFieldsValue(['policyType']);
    if (policyType) {
      setIsPolicyTypeSelected(policyType);
    }
  };
  const getPolicyGrouping = (event: any): any => {
    if (isPolicyWarningEnabled) {
      setPolicyWarn(policyWarning(event?.target?.value));
      setPolicyCheck(getPolicyCheck(event?.target?.value));
    } {
      if (isPolicyGroupEnabled) {
        setCurrentGrp(getPolicyGroup(event?.target?.value, shortName));
      }
    }
  };

  const policyNoSpaceCheck = (e: any): any => {
    if (shortName === 'HDFC') {
      e.target.value = e.target.value.trim().replace(/\s+/g, '');
    }
  };

  const getSearchUI = (): (ReactElement | null) => {
    if (isGovtScheme) {
      return <React.Fragment>
        <FormTextInput detail={{ ...commonDetail, key: 'employeeId', size: 12, isLoading, required: true, disabled: false }} />
      </React.Fragment>;
    } else if ((selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[0] ||
      selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[0] || selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[0])) {
      return <React.Fragment>
        <FormTextInput detail=
          {{
            ...commonDetail,
            key: 'memberId',
            size: 12,
            isLoading,
            onChange: memberIDvalidation,
            rules: (shortName === 'ABHI' && !memberIdCheck) ? [abhiValidation] : [],
            ...(isOptionalBenefFields ? {
              label: BENEF_CONSTANTS.MDID,
              placeholder: BENEF_CONSTANTS.MDI_PLACEHOLDER,
              addonBefore: MDI_MEMBERID_PREFIX,
              regex: ONLY_NUMBER_REGEX,
              ignorePrefixInput: true,
              className: 'benef-mdid-prefix',
            } : undefined),
          }} />
        {isOnlyMemberIdBenefField ?
          <FormTextInput detail={{
            ...commonDetail,
            key: 'policyNumber',
            onChange: getPolicyGrouping,
            onInput: (e: any): any => policyNoSpaceCheck(e),
            size: 12,
            rules: isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation],
            isLoading,
            isName: false,
            required: true,
            smallLabel: true,
          }} /> :
        <FormTextInput
          detail={{
            ...commonDetail,
            key: 'patientName',
            label: 'Patient Name',
            size: 12,
            isLoading,
            isName: true,
            smallLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
            required: true,
            rules: [
              { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
            ...(inMinCharacterValidationRequired ?  [{min : 4  , message : PATIENT_NAME_MIN_CHAR_LIMIT}] : [])],
            isMaxLengthNotApplicable: true,
          }} />
        }
        {memberIdCheck &&
          <Col>
            <Text type="secondary" className="ml-0 custom-group" style={{ color: '#3c3ada' }}>
              Bajaj Finance Numbers are not allowed,<br /> please enter proper member ID or Do a Policy Search.
            </Text>
          </Col>
        }
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[1] || selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[1]) {
      return <React.Fragment>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'employeeId',
          size: (dateOfBirthRequired) ? 12 : 7,
          required: true, isLoading,
          regex: (shortName === 'HDFC') ? null : /[^a-zA-Z\d\-]*/gm,
        }} />
        {
          isPolicyNoReqForEmpId ? (
            <>
              <FormTextInput detail={{
                ...commonDetail,
                key: 'policyNumber',
                onChange: getPolicyGrouping,
                size: isOptionalBenefFields ? 6 : 8,
                rules: isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation],
                isLoading,
                isName: false,
                required: isOptionalBenefFields ? false : true,
                smallLabel: isOptionalBenefFields ? true : false,
              }} />
              <FormTextInput detail={{
                ...commonDetail, key: 'corporateName', size: 8, required: true, isLoading,
                ...({ regex: CORPRATE_NAME_REGEX }),
              }} />
            </>
          ) :
            shortName === 'RGI' || isOptionalBenefFields ? (
              <FormTextInput
                detail={{
                  ...commonDetail,
                  key: 'policyNumber',
                  onChange: getPolicyGrouping,
                  size: 8,
                  rules: isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation],
                  isLoading,
                  isName: false,
                  required: true,
                }}
              />
            ) : dateOfBirthRequired ? (
              <FormInputDate
                detail={{
                  ...commonDetail,
                  key: 'dateOfBirth',
                  size: 12,
                  disabledDate: (current: any): boolean =>
                    checkIfDobDisabled(current),
                  hidden: false,
                }}
              />
            ) : (
              <FormTextInput
                detail={{
                  ...commonDetail,
                  key: 'corporateName',
                  size: 7,
                  required: true,
                  isLoading,
                  regex: CORPRATE_NAME_REGEX,
                }}
              />
            )
        }
        {!dateOfBirthRequired && <>

          <FormTextInput detail={{
            ...commonDetail,
            key: 'patientName',
            label: 'Patient Name',
            size: isOptionalBenefFields ? 9 : 10,
            isLoading, isName: true,
            smallLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
            required: true,
            rules: [{ max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT  },
            ...(inMinCharacterValidationRequired ?  [{min : 4  , message : PATIENT_NAME_MIN_CHAR_LIMIT}] : [])],
            isMaxLengthNotApplicable: true,

          }}
          />
        </>}
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[2] || selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[2]) {
      return <React.Fragment>
        {isOptionalBenefFields &&
          <FormSelect detail={{
            ...commonDetail,
            key: 'policyType',
            size: 12,
            allowClear: true,
            required: true,
            hidden: false,
            label: BENEF_CONSTANTS.POLICY_TYPE_LABEL,
            placeholder: 'Select',
            options: POLICY_TYPE_OPTIONS.SECTOR_TYPES,
            onChange: onChangePolicyType,
          }} />
        }
        {(!(isOptionalBenefFields) || !isEmpty(policyTypeValue)) &&
          <FormTextInput detail={{
            ...commonDetail,
            key: 'policyNumber',
            onChange: getPolicyGrouping,
            onInput: (e: any): any => policyNoSpaceCheck(e),
            size: 12,
            rules: isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation],
            isLoading,
            isName: false,
            required: true,
          }} />}
        {(!(isOptionalBenefFields) || !isEmpty(policyTypeValue)) &&
          <FormTextInput
            detail={{
              ...commonDetail,
              key: 'patientName',
              label: 'Patient Name',
              size: 12,
              isLoading, isName: true,
              smallLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              required: true,
              rules: [
              { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
              ...(inMinCharacterValidationRequired ? [{ min: 4, message: PATIENT_NAME_MIN_CHAR_LIMIT }] : [])],
              isMaxLengthNotApplicable: true,
            }} />
          }

          {(!isEmpty(policyTypeValue) && policyTypeValue === POLICY_TYPE_OPTIONS.SECTOR_TYPES[1]) &&
            <FormTextInput detail={{
              ...commonDetail,
              key: 'employeeId',
              size: 12,
              required: true,
              isLoading,
              regex: EMPLOYEE_ID_REGEX,
            }} />
        }
        <Col md={12}>
          {
            !policyWarn && !policyCheck &&
            <Text type="secondary" className="ml-0 custom-group" style={{ color: '#3c3ada' }}>
              Please verify the policy number format before submitting.
            </Text>
          }
          <Row>
            <Col>
              {
                currentGrp && isPolicyGroupEnabled && !policyCheck &&
                <Text type="secondary" className="ml-0 custom-group">
                  Policy type: <strong>{currentGrp}</strong>
                </Text>
              }
            </Col>
          </Row>
        </Col>
      </React.Fragment>;
    } else {
      return null;
    }
  };
  const getSearchOption = (): any[] => {
    // added shortname and removed employee id for abhi
    return isGovtScheme ? GOVT_SCHEME_SEARCH_OPTION[payerName] : (isOnlyMemberIdBenefField
      || isVoloIPPPayer) ? BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID : (shortName === 'ABHI' || isManipalPayer) ?
      BENEFICIARY_SEARCH_OPTION_ABHI : isOptionalBenefFields ? BENEFICIARY_SEARCH_OPTION_MDI :
          productNameTobeShown ? BENEFICIARY_SEARCH_OPTION_SHAI : BENEFICIARY_SEARCH_OPTION;
  };

  return (
    <>
      <Form
        layout="vertical"
        form={benefForm}
        validateMessages={VALIDATE_MESSAGES}
        onFinish={onClickSearch}
        requiredMark="optional"
        onValuesChange={validateFields}
        noValidate={true}
      >
        <Row gutter={GUTTOR_SPACE}>
          <FormSelect
            detail={{
              ...commonDetails,
              size: 12,
              allowClear: false,
              key: 'iHave',
              options: getSearchOption(),
              onChange: onSearchChange,
              required: true,
            }}
          />
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          {getSearchUI()}
          <Col
            md={24}
            className="text-right mt-sm"
          >

            <Button
              data-testid="beneficiary-search-button"
              type={!disable ? undefined : 'primary'}
              style={{ width: 120, height: 36 }}
              htmlType="submit"
              loading={loading}
              className={`his-next-button benef-margin-top-9
                  ${!disable ? 'benef-submit-disabled' : 'benef-submit-btn'}
                `}
              disabled={!disable}
            >
              <span id="WA_MEMBER_SEARCH">Search</span>
            </Button>
          </Col>
        </Row>
      </Form>

      {showRetryMessage && (!ClaimCreationWithoutBenef && !loading) ?
        (<Row className="benef-text-member-id m-md ">
          {displayMessage}
        </Row>
        )
        : null}
      {hyphenatedBasedGroupPolicy && combiPolicyExist &&
        (<div className="m-md-1">
          <Row className="benef-text-member-id">
            <p>
              <b>{GROUP_POLICY_HDFC}</b>
            </p>
          </Row>
        </div>
        )}
    </>
  );
};

export default BeneficiarySearchPanel;
